import { State, Action, StateContext, Selector } from '@ngxs/store';

import { UpdatePMDetail, ClearPMDetail } from '../actions/pm-detail.action';
import { PMDetail } from '../models/pm-detail.model';

export class PMDetailStateModel {
    pmDetail: PMDetail;

}

@State<PMDetailStateModel>({
    name: 'pmDetail',
    defaults: {
        pmDetail: null
    }
})

export class PMDetailState {

    @Selector()
    static getUsers(state: PMDetailStateModel) {
        return state.pmDetail;
    }




    @Action(ClearPMDetail)
    clearPMDetail({getState, setState }: StateContext<PMDetailStateModel>) {
        const state = getState();
        setState({
            pmDetail: null
        });
    }

    @Action(UpdatePMDetail)
    updatePMDetail({getState, setState }: StateContext<PMDetailStateModel>,  {payload}: UpdatePMDetail) {
        const state = getState();
        setState({
            pmDetail: payload
        });
    }


}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/state/pm-detail.state.ts